import { Upload, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { uploadMenuAssets } from "../actions/acc_actions";
import { useTranslation } from "react-i18next";

const MenuImageUploader = ({ form, initialImage }) => {
  const { t } = useTranslation();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (initialImage?.id && initialImage?.url) {
      setFileList([
        {
          uid: initialImage.id,
          name: "menu-image",
          status: "done",
          url: initialImage.url,
        },
      ]);
      // Populate form fields
      form.setFieldsValue({
        imageId: initialImage.id,
        imagePath: initialImage.url,
      });
    } else {
      setFileList([]);
    }
  }, [initialImage, form]);

  const handleUpload = async ({ file, onSuccess, onError }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("model", "PRODUCT");

      const res = await uploadMenuAssets(formData);

      if (res.data?.success) {
        const { id, path } = res.data.body;

        setFileList([{ uid: id, name: file.name, status: "done", url: path }]);

        form.setFieldsValue({ imageId: id, imagePath: path });

        onSuccess(res.data, file);
        message.success(t("image_uploaded_successfully"));
      } else {
        throw new Error("Upload failed");
      }
    } catch (err) {
      onError(err);
      message.error(t("upload_failed_try_again"));
    }
  };

  const handleRemove = () => {
    setFileList([]);
    form.setFieldsValue({ imageId: null, imagePath: null });
  };

  return (
    <Upload
      customRequest={handleUpload}
      listType="picture-card"
      fileList={fileList}
      onRemove={handleRemove}
      maxCount={1}
    >
      {fileList.length >= 1 ? null : (
        <div>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>{t("upload")}</div>
        </div>
      )}
    </Upload>
  );
};

export default MenuImageUploader;
